var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    section: true,
    'section-sustainability-v3': true,
    [`section${_vm.orderNo}`]: true
  }},[_c('a',{staticClass:"navigation-target",attrs:{"id":_vm.hash,"href":"javascript:void(0);"}}),_vm._v(" "),(_vm.data.title || _vm.data.subtitle)?_c('div',{staticClass:"top-title"},[_c('AtomsCommonAtomTitle',{attrs:{"title":_vm.data.title,"subtitle":_vm.data.subtitle}})],1):_vm._e(),_vm._v(" "),_c('OrganismsCommonOrganismCertificationsV2',{attrs:{"list-circle-data":_vm.data.items}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }